import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import DashboardLayout from "@/components/DashboardLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import EmployeesPage from "@/pages/EmployeesPage";
import AttendancePage from "@/pages/AttendancePage";
import LeavesPage from "@/pages/LeavesPage";
import PayrollPage from "@/pages/PayrollPage";
import PayslipsPage from "@/pages/PayslipsPage";
import LettersPage from "@/pages/LettersPage";
import SettingsPage from "@/pages/SettingsPage";
import ProfilePage from "@/pages/ProfilePage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import KycPage from "@/pages/KycPage";
import SalaryTemplatesPage from "@/pages/SalaryTemplatesPage";
import FinanceDashboard from "@/pages/finance/FinanceDashboard";
import ClientsPage from "@/pages/finance/ClientsPage";
import PlacementsPage from "@/pages/finance/PlacementsPage";
import InvoicesPage from "@/pages/finance/InvoicesPage";
import PaymentsPage from "@/pages/finance/PaymentsPage";
import IncentivesPage from "@/pages/finance/IncentivesPage";
import ReportsPage from "@/pages/finance/ReportsPage";
import CreditNotesPage from "@/pages/finance/CreditNotesPage";
import RecruiterJoinersPage from "@/pages/RecruiterJoinersPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="text-slate-400 text-sm">Loading...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="text-slate-400 text-sm">Loading...</div></div>;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="attendance" element={<AttendancePage />} />
        <Route path="leaves" element={<LeavesPage />} />
        <Route path="payroll" element={<PayrollPage />} />
        <Route path="payslips" element={<PayslipsPage />} />
        <Route path="letters" element={<LettersPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="kyc" element={<KycPage />} />
        <Route path="salary-templates" element={<SalaryTemplatesPage />} />
        <Route path="joiners" element={<RecruiterJoinersPage />} />
        <Route path="finance" element={<FinanceDashboard />} />
        <Route path="finance/clients" element={<ClientsPage />} />
        <Route path="finance/placements" element={<PlacementsPage />} />
        <Route path="finance/invoices" element={<InvoicesPage />} />
        <Route path="finance/payments" element={<PaymentsPage />} />
        <Route path="finance/incentives" element={<IncentivesPage />} />
        <Route path="finance/reports" element={<ReportsPage />} />
        <Route path="finance/credit-notes" element={<CreditNotesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
